import React from "react";
import "./../styles/HeaderTitle.css";

const DIVSTYLES = [
  "header-div--primary",
  "header-div--sub",
  "header-div--short",
];
const STYLES = ["header--primary", "header--sub"];

const SIZES = ["header--small", "header--medium", "header--large"];

const ALIGN = ["header--center", "header--left", "header--right"];

const COLOR = ["header--color"];

export const HeaderTitle = (props) => {
  const checkHeaderStyle = STYLES.includes(props.headerStyle)
    ? props.headerStyle
    : STYLES[0];

  const checkHeaderSize = SIZES.includes(props.headerSize)
    ? props.headerSize
    : SIZES[0];

  const checkDivHeaderStyle = DIVSTYLES.includes(props.divStyle)
    ? props.divStyle
    : DIVSTYLES[0];

  const checkDivHeaderAlign = ALIGN.includes(props.divAlign)
    ? props.divAlign
    : ALIGN[0];

  const checkDivHeaderColor = COLOR.includes(props.headerColor)
    ? props.headerColor
    : "";

  return (
    <div className={`${checkDivHeaderStyle}  ${checkDivHeaderAlign}`}>
      <label
        className={`header ${checkHeaderStyle} ${checkHeaderSize} ${checkDivHeaderColor}`}
      >
        {props.textContent}
      </label>
    </div>
  );
};
